import Loading from "./Loading";
type LoadingWrapperPropsType = {
    loading: boolean
    children?: React.ReactNode | React.ReactNode[]
}
const LoadingWrapper = (props: LoadingWrapperPropsType) => {
    return props.loading ? <Loading /> : <>{props.children}</>;
};
export default LoadingWrapper;
